declare namespace $ {

	type $mol_section__title_shm_hitalama_vk_analysis_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['title'] >
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_select__trigger_content_shm_hitalama_vk_analysis_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_select__dictionary_shm_hitalama_vk_analysis_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['lists_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_vk_analysis_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['selected_list_link'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_button_major__title_shm_hitalama_vk_analysis_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_vk_analysis_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['collect'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_shm_hitalama_vk_analysis_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_vk_analysis_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['collect_cancel'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_hitalama_vk_group_search__search_label_shm_hitalama_vk_analysis_9 = $mol_type_enforce<
		readonly($mol_view_content)[]
		,
		ReturnType< $shm_hitalama_vk_group_search['search_label'] >
	>
	type $shm_hitalama_vk_group_search__search_click_shm_hitalama_vk_analysis_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['cancel_select_list'] >
		,
		ReturnType< $shm_hitalama_vk_group_search['search_click'] >
	>
	type $shm_hitalama_vk_group_search__token_str_shm_hitalama_vk_analysis_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['token_str'] >
		,
		ReturnType< $shm_hitalama_vk_group_search['token_str'] >
	>
	type $shm_hitalama_vk_group_search__buttons_shm_hitalama_vk_analysis_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_vk_group_search['buttons'] >
	>
	type $mol_text__text_shm_hitalama_vk_analysis_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['selected_list_name'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_analysis_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_vk_analysis_summary__token_str_shm_hitalama_vk_analysis_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['token_str'] >
		,
		ReturnType< $shm_hitalama_vk_analysis_summary['token_str'] >
	>
	type $shm_hitalama_vk_analysis_summary__owner_ids_shm_hitalama_vk_analysis_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_analysis_summary['owner_ids'] >
	>
	type $shm_hitalama_vk_analysis_summary__posts_dto_by_owner_shm_hitalama_vk_analysis_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['posts_dto_by_owner'] >
		,
		ReturnType< $shm_hitalama_vk_analysis_summary['posts_dto_by_owner'] >
	>
	type $mol_labeler__title_shm_hitalama_vk_analysis_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_vk_analysis_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $shm_hitalama_vk_posts_table__title_shm_hitalama_vk_analysis_21 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_table['title'] >
	>
	type $shm_hitalama_vk_posts_table__owner_ids_shm_hitalama_vk_analysis_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_table['owner_ids'] >
	>
	type $shm_hitalama_vk_posts_table__Posts_by_owner_shm_hitalama_vk_analysis_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['Posts_by_owner'] >
		,
		ReturnType< $shm_hitalama_vk_posts_table['Posts_by_owner'] >
	>
	type $shm_hitalama_vk_posts_plots__title_shm_hitalama_vk_analysis_24 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_vk_posts_plots['title'] >
	>
	type $shm_hitalama_vk_posts_plots__owner_ids_shm_hitalama_vk_analysis_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['owner_ids'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots['owner_ids'] >
	>
	type $shm_hitalama_vk_posts_plots__group_name_shm_hitalama_vk_analysis_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['group_name'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots['group_name'] >
	>
	type $shm_hitalama_vk_posts_plots__Posts_by_owner_shm_hitalama_vk_analysis_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['Posts_by_owner'] >
		,
		ReturnType< $shm_hitalama_vk_posts_plots['Posts_by_owner'] >
	>
	type $mol_deck__items_shm_hitalama_vk_analysis_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_deck['items'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_analysis_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['loader_message'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__sub_shm_hitalama_vk_analysis_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type __shm_hitalama_vk_analysis_31 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_analysis['collect_by_owner'] >[0]
		,
		Parameters< $shm_hitalama_vk_analysis['Posts_by_owner'] >[0]
	>
	type __shm_hitalama_vk_analysis_32 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_analysis['collect_by_owner'] >[1]
		,
		Parameters< $shm_hitalama_vk_analysis['Posts_by_owner'] >[0]
	>
	type __shm_hitalama_vk_analysis_33 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_analysis['posts_dto_by_owner'] >[0]
		,
		Parameters< $shm_hitalama_vk_analysis['Posts_by_owner'] >[0]
	>
	type __shm_hitalama_vk_analysis_34 = $mol_type_enforce<
		Parameters< $shm_hitalama_vk_analysis['posts_pending'] >[0]
		,
		Parameters< $shm_hitalama_vk_analysis['Posts_by_owner'] >[0]
	>
	type $mol_text__text_shm_hitalama_vk_analysis_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__sub_shm_hitalama_vk_analysis_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_vk_posts__token_str_shm_hitalama_vk_analysis_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['token_str'] >
		,
		ReturnType< $shm_hitalama_vk_posts['token_str'] >
	>
	type $shm_hitalama_vk_posts__owner_id_shm_hitalama_vk_analysis_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_analysis['owner_id'] >
		,
		ReturnType< $shm_hitalama_vk_posts['owner_id'] >
	>
	export class $shm_hitalama_vk_analysis extends $mol_list {
		auto_collect( ): any
		Section( ): $mol_section
		search_reset( ): ReturnType< ReturnType< $shm_hitalama_vk_analysis['Search'] >['reset'] >
		search_title( ): string
		lists_dict( ): Record<string, any>
		selected_list_link( next?: string ): string
		List_select( ): $mol_select
		cancel_select_list( ): any
		search_owner_id( ): ReturnType< ReturnType< $shm_hitalama_vk_analysis['Search'] >['owner_id'] >
		search_dto( ): ReturnType< ReturnType< $shm_hitalama_vk_analysis['Search'] >['dto'] >
		collect( next?: any ): any
		Collect( ): $mol_button_major
		collect_cancel( next?: any ): any
		Cancel( ): $mol_button_major
		collect_button( ): readonly(any)[]
		Search( ): $shm_hitalama_vk_group_search
		selected_list_name( ): string
		List_name( ): $mol_text
		List( ): $mol_view
		list_view( ): readonly(any)[]
		Collect_block( ): $mol_view
		owner_ids( ): readonly(any)[]
		Summary( ): $shm_hitalama_vk_analysis_summary
		Summary_label( ): $mol_labeler
		Posts_table( ): $shm_hitalama_vk_posts_table
		group_name( id: any): string
		Plots( ): $shm_hitalama_vk_posts_plots
		Posts_deck( ): $mol_deck
		analysis( ): readonly(any)[]
		group_body( ): readonly(any)[]
		loader_message( id: any): string
		Loader_message( id: any): $mol_paragraph
		Loader( id: any): $mol_list
		owner_id( id: any, next?: string ): string
		collect_by_owner( id: any, next?: ReturnType< ReturnType< $shm_hitalama_vk_analysis['Posts_by_owner'] >['collect'] > ): ReturnType< ReturnType< $shm_hitalama_vk_analysis['Posts_by_owner'] >['collect'] >
		posts_dto_by_owner( id: any): ReturnType< ReturnType< $shm_hitalama_vk_analysis['Posts_by_owner'] >['dto'] >
		posts_pending( id: any): ReturnType< ReturnType< $shm_hitalama_vk_analysis['Posts_by_owner'] >['pending'] >
		title( ): string
		token( ): $shm_hitalama_vk_token | null
		token_str( ): string
		No_auth_message( ): $mol_text
		collect_queue( next?: readonly(string)[] ): readonly(string)[]
		auto( ): readonly(any)[]
		collect_pending( ): boolean
		sub( ): readonly(any)[]
		Loaders( ): $mol_list
		Posts_by_owner( id: any): $shm_hitalama_vk_posts
	}
	
}

//# sourceMappingURL=analysis.view.tree.d.ts.map